import React from "react";
import { Form, Input } from "antd";
import { UserOutlined } from "@ant-design/icons";

const RegisterOwnerFirstName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="firstName"
      label="Owner First Name"
      rules={[
        {
          required: true,
          message: "Please input owner first name",
        },
        {
          pattern: /^[A-Za-z ]+$/,
          message: "Alphabets only",
        },
      ]}
    >
      <Input
        showCount
        maxLength={32}
        prefix={<UserOutlined className="form-item-icon" />}
        placeholder="Owner First Name"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default RegisterOwnerFirstName;
